import { ChangeDetectionStrategy, Component, model } from '@angular/core';

@Component({
  selector: 'app-layout-container',
  templateUrl: './layout-container.component.html',
  styleUrls: ['./layout-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutContainerComponent {
  fixed = model<boolean>(false);
  fluid = model<boolean>(false);
}
